import React, { FC, MouseEvent } from "react";

import { Button, Icon } from "../../common";
import { useInvoiceCopyShareLink } from "../../../hooks/useInvoiceCopyShareLink";
import { Tooltip } from "../../common/Tooltip";

export type Props = {
  invoicePublicId?: string;
  label?: boolean;
  disabled?: boolean;
  className?: string;
  onCopy?: () => void;
  tooltip?: boolean;
};

export const CopyInvoiceLinkAction: FC<Props> = ({
  invoicePublicId,
  label,
  disabled,
  className,
  onCopy,
  tooltip = false,
}) => {
  const copyShareLink = useInvoiceCopyShareLink();

  const copyHandler = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (invoicePublicId && copyShareLink(invoicePublicId)) {
      onCopy && onCopy();
    }
  };

  const variant = label ? Button.variant.TERTIARY : Button.variant.SECONDARY;

  const button = (
    <Button
      contentClassName={className}
      disabled={disabled}
      icon={!label}
      onClick={copyHandler}
      variant={variant}
    >
      {label && <>Copy share link</>}
      <Icon icon="Link" size={24} className="text-gray-500" disableFill />
    </Button>
  );

  if (tooltip) {
    return (
      <Tooltip text="Copy share link" position="bottom">
        {button}
      </Tooltip>
    );
  }

  return button;
};
